module.exports = __webpack_public_path__ + "static/img/banner_content.1eefa3d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/banner_content.png
// module id = +n7i
// module chunks = 1